module.exports = __webpack_public_path__ + "img/arrow-left.f9c17057.svg";